import React from "react";
import { Link, useLocation } from 'react-router-dom';
import TextInput from "~/shared/form/TextInput";
import ControlledForm from "~/shared/form/ControlledForm";
import FormResponse from "~/shared/form/FormResponse";
import FormButton from "~/shared/form/FormButton";
import PublicPage from "./PublicPage";

export default function ResetPassword() {
    const { state } = useLocation();
    const fromPortal = (state?.fromPortal ?? "FAMILY").toLowerCase();

    return (
        <PublicPage title="Reset Password" forRole={fromPortal}>
            <ControlledForm noAsterisk className="flex flex-col" post="auth/request-reset" success="If a user with the given email exists, an email to reset your password has been sent.">
                <p className="text-neutral-600 mb-4">Enter your account's email address below. You'll receive an email with a link to reset your password.</p>
                <TextInput label="Email Address" id="email" placeholder="Enter email address" preset="email" required />
                <FormResponse className="mt-4" />
                <div className="flex flex-col gap-4 items-center mt-6">
                    <FormButton submit>Reset Password</FormButton>
                    <Link to={`/${fromPortal}-portal`} className="red-link">Return to Login</Link>
                </div>
            </ControlledForm>
        </PublicPage>
    );
}
